import { customerRoutes } from 'noddi-util';
import { Navigate, useParams } from 'react-router-dom';

/** Keeps early `/campaigns/from-code/:code` share links working. */
export const CampaignFromCodeLegacyRedirect = () => {
  const { code } = useParams<{ code: string }>();
  return <Navigate replace to={customerRoutes.campaignFromCode.getPath({ code: code! })} />;
};
